import React, { Dispatch, useEffect, useState } from 'react';
import { Form, Select, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Action } from 'typesafe-actions';
import { loadRequestProdutos } from '../../store/ducks/produtos/actions';
import { SelectResponsive } from './styles';
import { ProdutoProps } from './props';
import TextFilter from '../TextFilter';

const SelectProduto: React.FC<ProdutoProps> = ({ setProduto }) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const cddAtivo = useSelector((state: ApplicationState) => state.auth?.cddAtivo);
  const produtos = useSelector((state: ApplicationState) => state.Produtos.data);
  const loading= useSelector((state: ApplicationState) => state.Produtos.loading);
  // eslint-disable-next-line
  const [iconClose, setIconClose] = useState(true);
  // eslint-disable-next-line
  const [inscCDDAtivos, setinscCDDAtivos] = useState<any>();
  const [options, setOptions] = useState<any[]>([]);
  const { Option } = Select;
  const prodAll = localStorage.getItem(`produto${window.location.pathname}`);
  const dispatch = useDispatch<Dispatch<Action>>();


  useEffect(() => {
    const children = [];

    children.push(
      produtos?.map((inscData, index) => {
        return (
          <Option
            title={inscData.descricao}
            className="optionselect"
            value={inscData.descricao}
            key={inscData.codProduto}
          >
            {inscData.descricao} <br />
            Cod Referência: {inscData.codReferencia} <br />
            Cod Interno: {inscData.codProduto}
            <hr />
          </Option>
        )
      })
    );
    setOptions(children);
    setinscCDDAtivos({ inscricaoAtiva: inscricaoAtiva, CDD: cddAtivo?.codCdd });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produtos, inscricaoAtiva, cddAtivo]);

  const getProdutos = () => {
    dispatch(loadRequestProdutos(inscricaoAtiva, cddAtivo?.codCdd));
  };

  const onChange = (value: any, children: any) => {
    setProduto(children.key);
    localStorage.setItem(`produto${window.location.pathname}`, children.key);
  };

  return (
    <Form.Item label={<TextFilter>Produto</TextFilter>} name="produto">
      <SelectResponsive
        data-cy="selectProduto"
        showSearch
        optionLabelProp={setProduto}
        onFocus={getProdutos}
        onChange={onChange}
        defaultValue={!prodAll ? '' : prodAll}
        showiconclose={iconClose}
        filterOption={(inputValue, element) =>
          element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
        }
        loading={loading}
        notFoundContent={<Spin style={{textAlign:"center", width:"100%"}}/>}
      >
        {options}
      </SelectResponsive>
    </Form.Item>
  );
};

export default SelectProduto;
